import { Article, Button, Layout, Wrapper } from 'components';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Dp from '../../static/social/logo.png';
import { media } from '../utils/media';

const Content = styled.div`
  grid-column: 2;
  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.35);
  border-radius: 1rem;
  padding: 3rem 6rem;
  background: #ffffff;
  @media ${media.tablet} {
    padding: 3rem 2rem;
  }
  @media ${media.phone} {
    padding: 2rem 1.5rem;
  }
  overflow: hidden;
`;

const Hero = styled.div`
  text-align: center;
  grid-column: 2;
  padding: 3rem 2rem 6rem 2rem;
  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  color: ${props => props.theme.colors.grey.dark};

  p {
    font-size: 1.68rem;
    font-size: 105%;
    color: #ffffff;

    a {
      color: #ffffff;
      text-decoration: none;
      border-bottom: 1px solid ${props => props.theme.colors.primary};
      box-shadow: inset 0 -0.2rem 0 ${props => props.theme.colors.primary};
      transition: 0.2s all ease-out;

      &:hover {
        color: ${props => props.theme.colors.primary};
        box-shadow: inset 0 -1.5rem 0 ${props => props.theme.colors.accent};
        border-bottom: 0.3rem solid ${props => props.theme.colors.primary};
        -webkit-transform: translateY(-2px);
        -ms-transform: translateY(-2px);
        transform: translateY(-2px);
      }
    }

    margin-top: -1rem;
    @media ${media.phone} {
      font-size: 1.25rem;
    }
    @media ${media.tablet} {
      font-size: 1.45rem;
    }
  }
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.accent};
  text-shadow: 0 6px 0.4rem rgba(0, 0, 0, 0.35);

  img {
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.35);
    border-radius: 500rem;
  }
`;

const Sep = styled.span`
  color: ${props => props.theme.colors.grey.ultraLight};
`;

const Img = styled.a`
  img {
    width: 2.6rem;
    margin: 0;
  }
`;

const Subscribe = styled.div`
  margin: 4rem 0 -4rem;
`;

const Input = styled.input`
  background: #fff;
  border-radius: 500rem;
  width: 35%;
  font-size: 1.2rem;
  padding: 0.6rem 1.2rem;
  margin: 0.7rem -3rem 0 0;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.35);
`;

const Info = styled.div`
  margin: 0.4rem 0 0;
  font-size: 80%;
  color: rgba(220, 220, 220, 0.75);
`;

const IndexPage = ({
  data: {
    allMarkdownRemark: { edges: postEdges },
  },
}) => (
  <Layout>
    <Wrapper>
      <Hero>
        <Title>
          #OneDevMinute{' '}
          <Img href="https://twitter.com/MrAhmadAwais/" target="_blank" rel="noopener noreferrer">
            <img src={Dp} alt="Ahmad Awais" />
          </Img>
        </Title>
        {/* <p>
          Learn one development tip in one minute, daily with Ahmad Awais
          <br />— JavaScript #OpenSource Dev Advocate 🥑 <Sep>❯</Sep> 👓 WordPress Core Dev <Sep>❯</Sep> 📣 TEDx Speaker{' '}
          <Sep>❯</Sep> ⚛️ JS/DevOps fan boy <Sep>❯</Sep> ✍️ Published author CSS-Tricks, Tuts+Code, SmashingMag{' '}
          <Sep>❯</Sep> 💜 his wife MaedahBatool <Sep>❯</Sep> 🤣 Funnier than your mom <Sep>❯</Sep> You should become
          friends with him — <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">follow Ahmad on twitter @MrAhmadAwais →</a>
        </p> */}

        <p>
          Learn one development tip in one minute, daily with{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">
            Ahmad Awais
          </a>
          <br />
          🥑 JavaScript{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/AhmadAwais">
            #OpenSource
          </a>{' '}
          Dev Advocate <Sep>❯</Sep> 👓 WordPress Core Dev <br />
          📣 TEDx Speaker <Sep>❯</Sep> ⚛️ Frontend fanatice + DevOps fanboy <br />
          ✍️{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://AhmadAwais.com/">
            Published author
          </a>{' '}
          CSS-Tricks, Tuts+Code, SmashingMag <br />
          💜's his wife MaedahBatool <Sep>❯</Sep> 🤣 Funnier than your mom <br />
          🎯{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">
            Follow Ahmad on twitter @MrAhmadAwais →
          </a>
        </p>
        <Subscribe>
          <Input type="text" placeholder="🙌 best@email.here" />
          <Button big>
            <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
              <path d="M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z" />
            </svg>
            FREE SIGNUP
          </Button>
          <Info>#OneDevMinute delivered to your inbox. 👻 PINKY PROMISE.</Info>
        </Subscribe>
      </Hero>
      <Content>
        {/* <SectionTitle>🔥 #OneDevMinute</SectionTitle> */}
        {postEdges.map(post => (
          <Article
            title={post.node.frontmatter.title}
            date={post.node.frontmatter.date}
            excerpt={post.node.excerpt}
            slug={post.node.fields.slug}
            category={post.node.frontmatter.category}
            key={post.node.fields.slug}
          />
        ))}
      </Content>
    </Wrapper>
  </Layout>
);

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array.isRequired,
    }),
  }).isRequired,
};

export const IndexQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            # date(formatString: "DD.MM.YYYY")
            date(fromNow: true)
            category
          }
          excerpt(pruneLength: 200)
        }
      }
    }
  }
`;
